import { fetchPrivateApi } from '@/lib/api/apiServiceBase.ts';
import { DefaultCurrencyDto } from '@/features/dashboard/paymentConfig/types/DefaultCurrencyDto.ts';

const defaultCurrencyApi = {
  get: async (): Promise<DefaultCurrencyDto> => {
    return await fetchPrivateApi<DefaultCurrencyDto>(
      'GET',
      'settings/payments/default-currency',
    );
  },
  set: async (dto: DefaultCurrencyDto): Promise<DefaultCurrencyDto> => {
    return await fetchPrivateApi<DefaultCurrencyDto>(
      'PUT',
      'settings/payments/default-currency',
      dto,
    );
  },
};

export default defaultCurrencyApi;
